import { ReactComponent as Icon } from './statisticsIcon.svg'
import { theme } from '@ss/meta-core-components'
import React from 'react'
import { config } from '../../../config'

interface Props {
  ariaLabel?: string
  role?: string
}

export const StatisticsIcon: React.FC<Props> = ({
  ariaLabel = 'statistics',
  role = 'icon',
}) => {
  return (
    <Icon
      aria-label={ariaLabel}
      role={role}
      data-cy={'statistics-icon'}
      fill={
        theme.type === 'dark' ? config.iconColorDark : config.iconColorLight
      }
    />
  )
}
